import { render, staticRenderFns } from "./HubLimitReachedModal.vue?vue&type=template&id=487ad34e&"
import script from "./HubLimitReachedModal.vue?vue&type=script&lang=js&"
export * from "./HubLimitReachedModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports